// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { UserRepoService } from '@client/app/services/api/user-repo/user-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormUserComponent } from '@client/app/forms/user/user.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-users',
    template: `
        <page-header icon="fas fa-users" [header]="('Users' | translate)"
                     [subHeader]="subheaderTranslation">
            <page-header-content>
            <button data-test="add-user-button"
                    class="btn btn-border-radius btn-secondary pull-right outer-t-small"
                    monEventTrigger
                    [monEventParams]="{action: 'add-user-btn'}"
                    (click)="addUser()"
                    translate>+ Add new user
            </button>
            </page-header-content>
        </page-header>
        <div class="d-flex justify-content-end align-items-center mb-3">
            <csv-export-button clsSize="py-2 px-3" clsMargin="mr-0" [exports]="exports"></csv-export-button>
            <filter-button
                    [showFiltersBtn]="showFilters"
                    [(isFiltersOpen)]="isFiltersOpen">
            </filter-button>
            <table-search [model]="search"
                          (getPage)="onSearch($event)">
            </table-search>
        </div>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [collection]="users"
                        [progress]="promise">
                    <table-container-top>
                        <div class="outer-b merge-r-16 merge-l-16 merge-t-16" *ngIf="isFiltersOpen">
                            <table-filters [(open)]="isFiltersOpen"
                                           [(ngModel)]="filters"
                                           name="filters"
                                           [filters]="availableFilters"
                                           (onChanges)="onFiltersChanges($event)">
                            </table-filters>
                        </div>
                    </table-container-top>
                    <div>
                        <admin-users-table (getPage)="getPage()"
                                           [users]="users"
                                           [isAdmin]="true"
                                           [currentSort]="currentSort"
                                           (onPageSort)="onSortPageHandler($event)">
                        </admin-users-table>
                    </div>
                </table-container>
            </div>
        </div>
    `,
    standalone: false,
})
export class PagesUsersComponent extends BaseContainerComponentController implements OnInit {
    users: any = [];
    selectedRoles: any = [];
    subheaderTranslation: string = '';
    exports: any = [];
    promise: any;

    constructor (
        private userRepoService: UserRepoService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
    ) {
        super({ table: true, labels: true });
        this.currentSort.by = 'first_name';
        this.currentSort.direction = 'asc';
    }

    ngOnInit (): void {
        this.users = [];
        this.search = '';
        this.selectedRoles = [];
        this.filters.roles = [];
        this.subheaderTranslation = '';
        this.availableFilters.roles = [
            {
                id: true,
                name: 'Admin',
            },
            {
                id: false,
                name: 'Normal',
            },
        ];
        this.exports = [
            {
                name: this.translateService.getString('User Export'),
                data: {
                    category: 'users_with_domain_access',
                },
            },
        ];
        this.getPage();
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || null,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };
        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }
        if (this.selectedRoles.length > 0) {
            params.admin = this.selectedRoles[0].id;
        }
        this.promise = this.userRepoService.getAll(params).then((data: any) => {
            this.users = data;
            this.subheaderTranslation = this.translateService.getPlural(
                this.users.total,
                'You have 1 user on your account',
                'You have [[$count]] users on your account',
                {},
                '',
            );
        }, () => {});
    };

    addUser (user?: any): void {
        user = user || {};
        const params = {
            body: FormUserComponent,
            size: 'md',
            data: { user: user },
        };

        const callback = (userResult: any) => {
            if (userResult) {
                this.getPage();
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    onSortPageHandler (event: any): void {
        this.onSortPage(event.direction, event.by);
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        if (changes.changes) {
            changes = changes.changes;
        }
        if (changes.roles.length === 1) {
            this.selectedRoles = changes.roles;
        } else if (changes.roles.length > 1) {
            this.selectedRoles.splice(0, 1);
        } else {
            this.selectedRoles = [];
        }
        this.getPage();
    }

}
